// Core diagram structure with status placeholders
export const CORE_DIAGRAM = `
IN((IN - ###IN###))
AF((AF - ###AF###))
IM[IM - ###IM###]
QC{QC - Quality Control}
IN --> IM
`;

// Flow diagram templates with status placeholders
export const FLOW_DIAGRAMS = {
    STOCK: `
    IP[IP - ###IP###]
    subgraph STOCK Flow
      IM -- STOCK --> IP
      IP --> QC
      QC -- Approved --> AF
      QC -- Rejected --> IP
    end
  `,
    BRUT: `
    PB{PB - ###PB###}
    BT[BT - ###BT###]
    BL[BL - ###BL###]
    BZ[BG - ###BG###]
    GB[GB - ###GB###]
    GZ[GZ - ###GZ###]
    subgraph BRUT Flow
      IM -- BRUT --> PB
      PB -- Poeder beschikbaar --> BT
      PB -- Poeder niet beschikbaar --> BL
      BL -- Geleverd --> BT
      BT -- BRUT --> BZ
      BZ -- BRUT --> GB
      GB -- BRUT --> GZ
      BZ -- Skip boring --> GZ
      GZ --> QC
      QC -- Approved --> AF
      QC -- Rejected --> BZ
    end
  `,
    SPECIAL_REPAIR: `
    SP[SP - ###SP###]
    subgraph SPECIAL & REPAIR Flow
      IM -- SPECIAL --> SP
      IM -- REPAIR --> SP
      SP -- Klaar --> AF
    end
  `,
    EXTERN: `
    BF[BF - ###BF###]
    subgraph EXTERN Flow
      IM -- EXTERN --> BF
      BF -- Geleverd --> AF
    end
  `,
    SCENICA_EXTERN: `
    BT[BT - ###BT###]
    IPE[IPE - ###IPE###]
    subgraph SCENICA EXTERN Flow
      IM -- SCENICA_EXTERN --> BT
      BT -- SCENICA_EXTERN --> IPE
      IPE -- SCENICA_EXTERN --> AF
    end
  `,
    EXTERN_BRUT: `
    PB{PB - ###PB###}
    BF[BF - ###BF###]
    BT[BT - ###BT###]
    subgraph EXTERN BRUT Flow
      IM -- EXTERN_BRUT --> PB
      PB -- EXTERN_BRUT --> BF
      BF -- Geleverd --> BT
      BT -- EXTERN_BRUT --> AF
    end
  `,
    EXTERN_STOCK: `
    BF[BF - ###BF###]
    IP[IP - ###IP###]
    subgraph EXTERN STOCK Flow
      IM -- EXTERN_STOCK --> BF
      BF -- Geleverd --> IP
      IP --> QC
      QC -- Approved --> AF
      QC -- Rejected --> IP
    end
  `,
    LAKKERIJ: `
    PB{PB - ###PB###}
    BL[BL - ###BL###]
    subgraph LAKKERIJ Flow
      IM -- LAKKERIJ --> PB
      PB -- LAKKERIJ --> BL
      BL -- Geleverd --> AF
    end
  `,
    BRUT_PLOOI: `
    PT[PT - ###PT###]
    PO[PO - ###PO###]
    PK[PK - ###PK###]
    BT[BT - ###BT###]
    subgraph BRUT PLOOI Flow
      IM -- BRUT_PLOOI --> PT
      PT -- BRUT_PLOOI --> PO
      PO -- BRUT_PLOOI --> PK
      PK -- BRUT_PLOOI --> BT
      BT -- BRUT_PLOOI --> AF
    end
  `,
};
